import {useFetchMany, useFetchOne} from "../Lib/baseFetch";

export function useSections() {
  return useFetchMany('/referee/sections', undefined);
}

export function useSection(sectionId) {
  return useFetchOne('/referee/section/', sectionId);
}